import { TERMINAL } from '@/constants/cms';
import { jdiColorFetch } from '../colorFetchV2';
import {
  HOME_EVENT_NAMES,
  homeBusinessLogger,
  HOME_TRACK_TYPE,
} from '@/utils/logger/instance/homeBusinessLogger';

export enum ItemKetTypeEnum {
  URL = 'url',
  TEXT = 'text',
}

export const getCmsPageData = async (pageCode: string, healthCheck = false) => {
  const response = await jdiColorFetch('guide_homepage_getPageAllData', {
    method: 'POST',
    // cache: "no-store",
    headers: {
      // "Cache-Control": "no-cache",
    },
    bodyQuery: {
      pageCode,
      //language: "en_AS",
      pageType: 1,
      tenantCode: '__default__',
      businessType: 2,
      terminal: TERMINAL.H5,
      shopId: -1,
      systemType: 1,
    },
    next: { revalidate: 10 },
  });
  // ---------------- 首页接口监控告警 ---------------- //
  if (response?.code === '200') {
    return response;
  } else if (response?.code === '200262') {
    homeBusinessLogger({
      eventName: HOME_EVENT_NAMES.CMS_PARAMS_ERROR,
      category: {
        type: HOME_TRACK_TYPE.CMS_API_ERROR,
      },
      message: {
        pageCode: pageCode,
      },
    });
  } else if (response?.code === '100020') {
    homeBusinessLogger({
      eventName: HOME_EVENT_NAMES.CMS_NO_FLOOR,
      category: { type: HOME_TRACK_TYPE.CMS_API_ERROR },
      message: {
        pageCode: pageCode,
      },
    });
  } else {
    homeBusinessLogger({
      eventName: HOME_EVENT_NAMES.CMS_INIT_ERROR,
      category: { type: HOME_TRACK_TYPE.CMS_API_ERROR },
      message: {
        pageCode: pageCode || -1,
        code: response?.code || -1,
        msg: response?.msg || '-100',
      },
    });
  }

  return response;
};

export const getCmsPreviewData = async (pageId: number, pageCode: string) => {
  const response = await jdiColorFetch('guide_homepage_preview', {
    method: 'POST',
    // cache: "no-store",
    headers: {
      // "Cache-Control": "no-cache",
    },
    bodyQuery: {
      pageCode,
      //language: "en_AS",
      pageType: 1,
      tenantCode: '__default__',
      businessType: 2,
      terminal: TERMINAL.H5,
      shopId: -1,
      systemType: 1,
      pageId: pageId,
      terminalRootType: 1,
    },
    next: { revalidate: 10 },
  });
  return response;
};

export const getCmsShareText = async (type: ItemKetTypeEnum, key: string) => {
  const response = await jdiColorFetch('basic_config_getBaseURL', {
    method: 'POST',
    bodyQuery: { keyList: [{ key: key, type: type }] },
  });
  return response;
};
